/**
 * Created by Victor Rojo on 23/10/18.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Injectable()
export class RuleService{

  private basePath = "api/v1/rule/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  executeRule(ruleId:string): Promise<any>{
    let url = this.basePath + ruleId;
    return this.http.post(url,null, { responseType: 'text' })
      .toPromise()
      .catch( error => this.errorHandler(error) );
  }

}
